<template>
    <div >
        <div class="row no-gutters body">
            <div class="col-12">
                <div class="row no-gutters">
                    <div class="col-lg-3 middle-background"></div>
                    <div class="col-md-12 col-lg-6 middle-background main-card pb-5" :class="{'col-lg-9 ml-0 mr-0 ' :selectedJobsPage === true}">
                        <div class="row no-gutters">
                            <br />
                        </div>
                        <div class=" no-gutters mt-5 "  >
                            <div class="col-lg-12"> 
                                <div class="row no-gutters">
                                    <br />
                                </div>
                                <nav class="nav card-header1 d-flex justify-content-between  ml-3 mr-3 mt-2" id="nav">
                                    <div class="proximanova-bold blue fontsize12">
                                        <div class=" no-gutters">
                                            <ul class="nav nav-tabs ">
                                                <li class="nav-item pointer" > 
                                                    <a 
                                                    class="proximanova"
                                                    @click="changeActiveClass('people')"
                                                    :class="{'proximanova-semibold blue border-tab':activeClass == 'people'}"
                                                    id="people"                                                            
                                                    >People</a>
                                                </li>
                                                <div class="verticaline mt-1"> | </div>
                                                <li class="nav-item pointer" > 
                                                    <a 
                                                    class="proximanova"
                                                    @click="changeActiveClass('company')"
                                                    :class="{'proximanova-semibold blue border-tab':activeClass == 'company'}"
                                                    id="company"                                                            
                                                    >Company</a>
                                                </li>
                                                <div class="verticaline mt-1"> | </div>
                                                <li class="nav-item pointer"> 
                                                    <a 
                                                    class="proximanova" 
                                                    @click="changeActiveClass('job')"
                                                    :class="{'proximanova-semibold blue border-tab':activeClass == 'job'}"
                                                    id="job"                                                            
                                                    >Jobs</a>
                                                </li>
                                                <!-- <div class="verticaline mt-1"> | </div>
                                                <li class="nav-item "> 
                                                    <a  
                                                    class="proximanova"
                                                    :class="{'proximanova-semibold blue border-tab':activeClass == 'product'}"
                                                    id="product"                                                            
                                                    >Products</a>
                                                </li>
                                                <div class="verticaline mt-1"> | </div>
                                                <li class="nav-item"> 
                                                    <a
                                                    class="proximanova"
                                                    :class="{'proximanova-semibold blue border-tab':activeClass == 'video'}"
                                                    id="video"                                                            
                                                    >Videos</a>
                                                </li>            -->
                                            </ul>
                                        </div>
                                    </div>
                                    <div class="d-flex mr-1" >
                                        <!-- <label class=" proximanova black60 fontsize12 mt-2 text-font">More</label>
                                        <img src="../assets/Filter.svg" style="width:15px" class="img-fluid img-padding" />                                             -->
                                    </div>
                                </nav>
                        </div>
                    </div>
                    <div v-if="activeClass === 'people'">
                        <people-search-list></people-search-list>
                    </div>
                    <div v-if="activeClass === 'company'">
                        <company-search-list></company-search-list>
                    </div>
                    <div v-if="activeClass === 'job'"      >
                        <job-search-list></job-search-list>
                    </div> 
                </div>
                <div class="col middle-background" v-if="selectedJobsPage === false">
                    <div class="row no-gutters">
                        <br />
                    </div>
                    <div class="row row no-gutters">
                        <br />
                    </div>
                    <pendingActivities />
                </div>
            </div>
        </div>    
        </div>
    </div>
</template>
<script>
import sidemenu from "@/components/SideMenu.vue";
import pendingActivities from "../components/PendingActivities.vue";
import topmenu from "@/components/TopHeader.vue";
import httpuserprofile from "@/js/http-userprofile.js";
import Footer from "../components/Footer";
import PeopleSearchList from "./PeopleSearchResults.vue"
import JobSearchList from "./JobSearchList.vue"
import CompanySearchList from "./CompanySearchResults.vue"
import sessionUtils from '@/js/session-util.js'
import { bus } from "../main";
export default {
    components: {
    sidemenu,
    topmenu,
    pendingActivities,
    PeopleSearchList,
    JobSearchList,
    CompanySearchList,
    Footer   
  },
    data(){
        return {          
            activeClass: "people",
            noResultsLength: 4,
            selectedJobsPage:false,
            selectedTab: '',
            searchText : '',
            selectedUserInSamePage : false,
        }
    },
    watch: {
        '$route.params.text': function () {
            this.searchText= this.$route.params.text;
            this.activeClass= this.$route.params.searchType;
            this.selectedUserInSamePage = false;
            this.changeActiveClass(this.activeClass)
        },
        '$route.params.searchType': function () {
            this.activeClass= this.$route.params.searchType;
            this.searchText = this.$route.params.text;
            this.selectedUserInSamePage = false;
            this.changeActiveClass(this.activeClass)
        }
    },
    methods: {
        changeActiveClass(type){
            console.log("no of times callimg : ", type)
            // this.activeClass = type;
            // sessionUtils.setSelectedSearchTab(type)
            console.log("search text : ", this.searchText)
            // if(this.selectedUserInSamePage){
            this.$router.push({name: 'searchResults', params: { text: this.searchText, searchType : type}});
            // }else{
            //     this.selectedUserInSamePage = true;
            //     this.activeClass = type;
            // }
            if(type === 'job'){
                this.selectedJobsPage = true
            }else{
                this.selectedJobsPage = false
            }
        },
    },    
    created(){        
        window.scrollTo(0, 0);  
        // this.selectedTab = sessionUtils.getSelectedSearchTab();
        this.selectedTab = this.$route.params.searchType;
        this.searchText = this.$route.params.text;
        console.log(this.selectedTab)
        this.activeClass = this.selectedTab
        if(this.activeClass === 'job'){
            this.selectedJobsPage = true
        }
        bus.$on('openingJobs', (data) => {
            if(data === true){
                this.selectedJobsPage = data;
            }            
        })
        // bus.$on('openSearchTab', (data) => {
        //     if(data){
        //         if(data !== this.activeClass) {
        //             this.changeActiveClass(data)
        //         }
        //     }
        // })
    },
    beforeDestroy() {
        bus.$off('openingJobs')
        bus.$off('openSearchTab')
    }
}
</script>
<style scoped>
html,
body,
.grid {
    height: 100%;
    width: 100%;
    background: green;
}
.loadingBgImg{
  background: transparent url('../assets/loading_gif1.gif') center no-repeat;
  background-size: 30px 30px;
}
.loadingBgImg1{
    background: transparent url('../assets/loading_gif1.gif') center no-repeat;
  background-size: 20px 20px;
}
.footer {
    position: fixed;
    bottom: 0;
}
.img-padding{
    margin-left: 2px;
    margin-bottom: 2px;
}
.list-group-item{
    padding: .25rem 0.25rem;
    border: none;
    border-radius: 5px;
}
.list-group-item:hover{
    background: rgba(31,31,31,.1);
}
.modal-footer{
    background-color: #ffffff
}
.profilestrength {
    margin-left: 0px !important;
}
.line1 {
    display: block;
    height: 1px;
    border: 0;
    padding: 0;
    border: 1px solid #1f1f1f;
    opacity: 0.1;
}
.imgborder1 {
    padding: 10px 15px 10px 10px;
    background-color: rgba(161, 166, 179,0.1);
    border-radius: 0px 10px 10px 0px;
}
.horizonline1{
    border-bottom: 1px solid #E9EBF0;
}
.navtoPage {
    transition : ease-out 0.3s;
    POSITION : relative;
    z-index : 1;
    padding-left : 5px;
    padding-top: 2px;
    cursor: pointer;
    /* color: #0078FF !important; */
    /* border: 1px solid #0078FF; */
    /* border-radius: 16px;
    padding-left: 5px !important; */
}
.navtoPage::before {
	transition : 0.5s all ease;
	position : absolute;
	top : 0;
	left : 30%;
	right : 30%;
	bottom : 0;
	opacity : 0;
	content : "";
    border-radius: 20px;
	background-color :  rgba(29, 27, 27, 0.1);
}
.sign-in-button{
	font-family: "Proxima Nova";
	font-size: 16px;
	font-weight: 600;
	color: #1F1F1F;
	opacity: 30%;
	transition : ease-out 0.3s;
	POSITION : relative;
	z-index : 1
  }
  .sign-in-button::before {
	transition : 0.5s all ease;
	position : absolute;
	top : 0;
	left : 30%;
	right : 30%;
	bottom : 0;
	opacity : 0;
	content : "";
	background-color :  rgba(255,255,255,.3);
  }
  .sign-in-button:hover:before {
	transition : 0.5s all ease;
	left : 0;
	right : 0;
	opacity : 1;
	z-index : -1
  }
.navtoPage:hover:before {
    cursor: pointer;
	transition : 0.5s all ease;
	left : 0;
	right : 0;
	opacity : 1;
	z-index : -1
}
.padding-top{
    position: absolute;
    right: 2%;
}
#followImage1{
    width: 30px;
    height: 30px;  
}
#follow a:hover{
    color: white !important;
}

.closebtnmouseover {
    padding-top: 2px;
    padding-left: 2px;
    padding-right: 2px;
    border: 1px solid white;
}
.closebtnmouseover:hover {
  /* margin-top: -4px;
  background-color: rgba(161, 166, 179,0.1);
  border-radius: 60%;
  padding-left: 6px;
  padding-right: 3px; */
  background-color: rgba(161, 166, 179,0.1);
  border-radius: 60%;
  border: 1px solid rgba(161, 166, 179,.5);
}
.input-group-append{
    margin-left: 0  !important;
}
#nameBlock:hover{
    color:#007AFF !important;
}
.card-img-overlay:hover #playvideobtn{
	display: block !important;
}
.display-button{
    display: none !important;
}
.text-color{
    color: #0078ff;
    font-size: 12px;
}
.button-create-font {
    font-family: "Proxima Nova";
    font-size: 16px;
    font-weight: bold;
}
#filterDropdown{
    left : 57%;
    z-index: 5;
    overflow-y: scroll;
    overflow-x: hidden;
    height: 360%;    
}
.searchtext{
    border-radius: 10px;
    background-color: rgba(161, 166, 179,0.1);
    border: #DDDFE5;  
}
#profilevideo{
    width: 100%;
    border-radius: 4%; 
    object-fit: fill;
}
.card-padding{
    padding-right: 0px !important;
}
.badge{
    transform: scale(1.6) !important;
    width: 23px;
    padding-top: 6px;
    height: 23px;
    font-size: 50%;
}
.pageloader {
    width: 7%;
    margin-top: 15%;
    margin-left: 46%;
}
.vbottom{
    position: relative;
    top: 100%;
    transform: translateY(-100%); 
}
.no-record-card{
    background-color: #A1A6B3 !important;
    opacity: 6%;
    height: 15rem;
    border-radius: 10px;
}
.top-margin{
    margin-top: -300px !important;
    margin-left: auto;	
    margin-right: auto;	
    display: block;
}
.font12-reg{
	/* color: rgba(52, 73, 94, 0.8); */
	font-family: 'Proxima Nova Regular';
	/* font-weight: bold; */
	font-size: 12px;
  }
.max-height{
    height: 15rem;
}
.dropdown-menu{
    display:block;    
    color: black;
    box-shadow: 0px 8px 16px 0px rgba(0,23,56,0.1);
    border: none;
    /* min-width:100%; */
    margin-top: 0px;   
    z-index: 3 !important;
    border-radius: 10px  !important;
}
.right-align{
    margin-right: 10px;;
}
.card-img-overlay {
    padding: 0 !important;
}
.black_overlay1 {
    background: linear-gradient(0deg, rgba(0,0,0,0) 0%, #000000 100%);
    border-radius: 4px 4px 5px 4px;
}
.black_overlay2 {
    background: linear-gradient(180deg, rgba(0,0,0,0) 10%, #000000 100%);
    border-radius: 0 4px 5px 4px;
}
.card-img-overlay:hover #playvideobtn{
    display: block;
}
#playvideobtn {
    display: block;
    margin-left: 45%;
    margin-top: 15%;
    margin-bottom: 5%;
    cursor: pointer;
}
.no-image{
    margin-bottom: 5%;
}
.footer {
    position: fixed;
    bottom: 0;
  }
.modal-content{
    border-radius: 10px  !important;
}
.modal-height{
    height: auto;
    margin-top: 5% !important;
    width: 100% !important;
    border-radius: 10px !important;
}
.text-design{
    background-color: #A1A6B3;
    /* opacity: 10%; */
    color: black;    
}
#bottom {
    position: absolute;
    width: 100%;
    bottom: 0;
    left: 0;
}
.modal-body{
    background-color: #000000
}
.header {
    position: fixed;
    width: 100%;
    z-index: 10;
    background: #ffffff;
    border-bottom: 2px solid rgba(219, 219, 219,1);
}
.header__content-text {
    text-align: center;
    padding: 15px 20px;
}
.nav-tabs {
    border-bottom: none !important;
}
.card-header {
    padding: 5px 10px 5px 10px;
    margin-bottom: 0;
    border: 1px solid #d9dce1;
    opacity: 0.6;
    border-radius: 8px;
    /* background-color: #f0f2f5; */
}
.footer{
    z-index: 5;
}
.card-header1 {
    /* padding: 5px 10px 5px 10px;
    margin-bottom: 0; */
    border: 1px solid #d9dce1;
    opacity: 0.6;
    border-radius: 8px;
    /* background-color: #f0f2f5; */
}
.nav{
    background-color: #f0f2f5  !important; 
    border-radius: 8px !important;
}
.video-player{
    border-radius: 20px; 
    overflow: hidden; 
    /* opacity: 60%; */
}
.welcomename {
    /* margin-top: -7px !important; */
    font-size: 14px !important;
}
.dot {
    height: 45px;
    width: 45px;
    background-color: #1F1F1F;
    border-radius: 50%;
    display: inline-block;
}
.btn-color{
    border-color: #1F1F1F;
}
.navbar {
    padding: 0px 0px 0px 0px !important;
    z-index: 100;
}
.nav{
    flex-wrap: unset !important;
}
.padding-follow{
    margin-bottom:  0.5rem;
}
.list-text-color {
    color: #0078ff;
    /* font-family: "Proxima Nova"  !important; */
    /* font-size: 16px; */
    font-weight: bold;
    letter-spacing: 0;
}
.check-with-label:checked + .label-for-check {
    font-weight: bold;
}
.text-color1{
    color: #FFFFFF !important;
    font-size: 14px  !important;
}
.text-color2{
    color: #FFFFFF !important;
    font-size: 12px  !important;
}
.border-tab {
    border-bottom-style: solid;
    border-bottom-color: #0078ff;
}
#profImage{
    width: 45px;
    height: 45px;
    border:1px solid #ced4da;
}
#profImage:hover{
    border: 1px solid #007AFF;
}
.hover {
    cursor: pointer;
  /* color: #0078FF; */
}
.video{
     width: 100%;
}
#followImage{
    width: 30px;
    height: 30px;
    transform: scale(1.2)  !important;
    border: 1px solid #1F1F1F;
}
.font12-bold_filter{
	font-size: 14px;
	font-weight: bold;
	color: #1F1F1F;
  }
#follow{
	transition : ease-out 0.3s;
	POSITION : relative;
	z-index : 1;
    text-align: right;
    /* right: 5%; */
    padding-left : 5px;
    padding-top: 2px;
    padding-right: 5px;
    padding-bottom: 2px;
}
#follow::before {
	transition : 0.5s all ease;
	position : absolute;
	top : 0;
	left : 30%;
	right : 10%;
	bottom : 0;
	opacity : 0;
	content : "";
	background-color :  rgba(31,31,31,.3);
}
#follow:hover:before {
	transition : 0.5s all ease;
	left : 0;
	right : 0;
    padding-left:5px;
	opacity : 1;
	z-index : -1;
    padding-bottom: 5px;    
    padding-right: 10px !important;
    padding-top: 5px !important;
    border-radius:4px;
}
#following{
    transition : 0.5s all ease;
	position : relative;
    background-color: #007AFF;        
    border-radius: 4px;
    padding-bottom: 5px;    
    padding-right: 10px !important;
    padding-top: 5px !important;
    padding-left: 10px !important;
    z-index : 1;
    text-align: right;
    /* right: 5%; */
}
#following::before {
	transition : 0.5s all ease;
	position : absolute;
	top : 0;
	left : 50%;
	right : 50%;
	bottom : 0;
	opacity : 0;
	content : "";
	background-color :  rgba(255,255,255,.3);
}  
#following:hover:before {
	transition : 0.5s all ease;
	left : 0;
	right : 0;
    padding-left:5px;
	opacity : 1;
	z-index : -1;
    padding-bottom: 5px;    
    padding-right: 10px !important;
    padding-top: 5px !important;
    border-radius:4px;
}
.sign-up-button:hover:before {
	transition : 0.5s all ease;
	left : 0;
	right : 0;
	opacity : 1;
	z-index : -1
}
#following a{
    margin-left:5px;
    color: #FFF !important;
    cursor: pointer;
}
.badge-success {
    color: #fff;
    background-color:black;
}
.badge-fill {
    padding-right: .6em;
    padding-left: 0.8em;
    border-radius: 10rem;
}
.form-control:focus{
    outline: none !important;
    box-shadow: none !important;   
    border-radius: 10px;
    background-color: rgba(161, 166, 179,0.1);
    border: #DDDFE5;   
}
input:focus,
textarea:focus {
    outline: none; /** For Safari, etc **/
    border: transparent;
}

.noResult{
    zoom: 6;
    margin-left: 5px;
    margin-top: -60px;
}
.padding{
    padding: 5px !important;
}
.card {
  border: 1px solid #dddfe5;
  border-radius: 10px;
  background-color: #ffffff;
}
.card-img-top {
    /* width: 100%;
    height: 15vw; */
    object-fit: cover;
}
.font12-60opacity{
	font-size: 12px;
	color: rgba(31,31,31,.6);
	font-family: 'Proxima Nova Regular';
}
@media screen and (max-width: 1020px) and (min-width: 767px) {
  .main-card {
    padding-left: 5% !important;
    padding-right: 5% !important;
  }
}

@media only screen and (max-width: 600px) {
    .text-color2{
        font-size: 10px !important;
    }
    .font16-bold{
        font-size: 12px;
    }
    .pageloader {
    width: 20%;
    margin-top: 25%;
  }
    .padding-top{
        padding-top: 0.8rem;
        /* font-size:10px */
    }
    #following{
        margin-left: 0%;
    }
    #following a{
        font-size: 8px;
    }
    #follow a{
        font-size: 8px;
        /* padding-bottom: 1rem !important; */
    }
    /* .fontsize12{
        font-size: 10px !important;
    } */
    .font12-bold{
        font-size: 10px  !important;
    }
   
    .font12-reg{
        font-size: 8px !important;
    }
   
     .topmenubar {
    margin-left: 1.5em;
  }
  .loadingBgImg{
        background-size: 20px 20px;
    }
    .loadingBgImg1{
        background-size: 15px 15px;
    }
}
@media screen and (min-width: 300px) and (max-width: 350px) {
    #filterDropdown{
        left : 47% 
    }
    .text-font{
        font-size: 10px;
    }
    #playvideobtn {
        margin-left: 40%;
        margin-top: 25%;
    }
    #followImage{
        width: 12px;
        height: 12px;
        transform: scale(1.6)  !important;
        /* border: 1px solid black; */
    }
}
@media screen and (min-width: 300px) and (max-width: 400px) {    
    .font16-bold{
        font-size: 8px;
    }
    .bold16px_white{
        font-size: 8px;
    }
}
@media screen and (min-width: 350px) and (max-width: 400px) {
    #filterDropdown{
        left : 47% 
    }
    #playvideobtn {
        margin-left: 40%;
        margin-top: 35%;
    }
    .text-font{
        font-size: 10px;
    }
    #followImage{
        width: 15px;
        height: 15px;
        transform: scale(1.6)  !important;
    /* border: 1px solid black; */
    }
    nav ul li a {
        display: block;
        padding: 0.5rem 0.8rem !important;
        color: grey;
        text-decoration: none;
        display: block;
        flex: 0 1 auto;
        list-style-type: none;
        /* background: #fafafa; */
        font-size: 10px;
        max-width: 200px;
    }
}
@media screen and (min-width: 300px) and (max-width: 400px) {
    nav ul li a{
        padding: 0.5rem 0.5rem;
    }
    .text-font{
        font-size: 10px;
    } 
    #profImage{
        width: 40px;
        height: 40px;
    }
}
@media screen and (min-width: 400px) and (max-width: 500px) {
    #filterDropdown{
        left : 47% 
    }
    #followImage{
        width: 18px;
        height: 18px;
    }
    #playvideobtn {
        margin-left: 40%;
        margin-top: 30%;
    }
}
@media screen and (min-width: 500px) and (max-width: 600px) {
    #filterDropdown{
        left : 47% 
    }
    #playvideobtn {
        margin-left: 45%;
        margin-top: 25%;
    }
}
@media screen and (max-width: 900px) and (min-width: 600px) {
    #filterDropdown{
        left : 54% 
    }
    #playvideobtn {
        margin-left: 45%;
    }
}
@media screen and (max-width: 900px) and (min-width: 800px) {
    #filterDropdown{
        left : 55% 
    }
    #playvideobtn {
        margin-left: 45%;
        margin-top: 15%;
    }
}
@media screen and (min-width: 900px) and (max-width: 1100px) {
    #playvideobtn {
        margin-left: 45% !important;
    }
}
@media screen and (min-width: 900px) and (max-width: 1295px) {
    #followImage{
        width: 25px;
        height: 25px;
        transform: scale(1.2)  !important;
        border: 1px solid #1F1F1F;
    }   
}
</style>
